import React from 'react';
import { Icons } from '@ems/client-design-system';

export const searchIcon = <Icons iconName="ic-ui-search" className="ic-ui-search" />;
export const chevronIcon = <Icons iconName="ic-ui-chevron-down" className="ic-ui-chevron-down" />;
export const crossIcon = <Icons iconName="ic-ui-cancel-sm" />;
